<template>
  <div class="table-wrapper">
    <table class="fixed-head">
      <thead>
        <tr>
          <th v-for="item in data.head">{{item}}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="items in data.body">
          <td v-for="item in (items.data || items)">
            <span v-if="item.html" v-html="item.html"></span>
            <template v-else>{{item}}</template>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="scroll-content">
      <table class="content">
        <thead>
          <tr>
            <th v-for="item in data.head">{{item}}</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="items in data.body" :class="items.className">
            <td v-for="item in (items.data || items)">
              <span v-if="item.html" v-html="item.html"></span>
              <template v-else>{{item}}</template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'Table',
  props: {
    data: Object,
  },
  methods: {

  },
};
</script>

<style scoped lang="scss">
.table-wrapper {
  th,
  td {
    padding: 0;
    max-width: 30vw;
    text-align: center;
  }

  .scroll-content {
    height: calc(100% - 35px);
    overflow-y: auto;
  }

  .fixed-head,
  .content {
    border-spacing: 0;
    background-color: #fff;
    width: 100vw;
  }

  .fixed-head tbody,
  .content thead {
    line-height: 0;
    opacity: 0;
  }

  thead {
    font-size: 14px;
    line-height: 35px;
    font-weight: bold;
  }

  tbody {
    font-size: 12px;
    line-height: 30px;
    text-align: center;

    tr:nth-child(odd) {
      background-color: rgba(0, 0, 0, .2);
    }

    .week {
      border-bottom: 2px solid #e51c23;
    }
  }
}
</style>
